module.exports = __webpack_public_path__ + "static/img/9.bb35fa5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/1/sp/9.png
// module id = x1bK
// module chunks = 0